export function formatNumber(num) {
  if (isNaN(num)) return '';
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
}
